import * as React from 'react';
import { PropsWithChildren, ReactNode, useState } from 'react';
import { AdminJobsManagement } from './AdminJobsManagement';
import AdminJobEntriesManagement from './AdminJobEntriesManagement';

export type PageType = 'JOBS' | 'JOB_ENTRIES'

interface AdminJobWrapperProps {
  setPageIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AdminJobWrapper: React.FC<PropsWithChildren<AdminJobWrapperProps>> = (props: PropsWithChildren<AdminJobWrapperProps>): ReactNode => {
  const {setPageIsLoading} = props;
  const [currentPage, setCurrentPage] = useState<PageType>('JOBS');
  const [jobId, setJobId] = useState<number>(undefined);

  return (
    <>
      {currentPage === 'JOB_ENTRIES' &&
        <AdminJobEntriesManagement setCurrentPage={setCurrentPage} jobId={jobId} setJobId={setJobId} setPageIsLoading={setPageIsLoading} />
      }
      {currentPage === 'JOBS' &&
        <AdminJobsManagement setCurrentPage={setCurrentPage} setJobId={setJobId} />
      }
    </>
  );
}

export default AdminJobWrapper;
